import {SurveyFont, SurveyTheme} from "crqlar-react-common/dist/models/survey/survey.model";
import {FontValue, googleFontsCss, SYSTEM_SANS} from "../../common/newFontPicker/fonts";

const BUILT_IN_FAMILIES: Record<SurveyFont, string> = {
    [SurveyFont.ROBOTO]: 'Roboto',
    [SurveyFont.INTER]: 'Inter',
    [SurveyFont.PUBLIC_SANS]: 'Public Sans',
    [SurveyFont.POPPINS]: 'Poppins',
};

/**
 * The survey's font as saved, for the picker, the preview and the guest page alike. A survey saved before
 * fontSource keeps its built-in font, read as that Google font so it actually loads; neither is Standard.
 */
export const surveyFontOf = (theme?: SurveyTheme): FontValue => {
    if (theme?.fontSource) return {fontSource: theme.fontSource, fontUrl: theme.fontUrl, fontFamily: theme.fontFamily};
    if (!theme?.font) return {fontSource: 'STANDARD', fontUrl: '', fontFamily: ''};
    const family = BUILT_IN_FAMILIES[theme.font];
    return {fontSource: 'GOOGLE', fontUrl: googleFontsCss(family, '400;600;700'), fontFamily: `"${family}", ${SYSTEM_SANS}`};
};

/** The CSS font-family the guest page uses: the chosen font's, else the device's own. */
export const surveyFontFamily = (theme?: SurveyTheme): string => {
    const {fontSource, fontFamily} = surveyFontOf(theme);
    return fontSource !== 'STANDARD' && fontFamily?.trim() ? fontFamily : SYSTEM_SANS;
};
